import { Observable } from 'rxjs/Rx';
import { ConfirmDialog } from '../dialogs/confirm/confirm-dialog.component';

import { XpoDialog, XpoDialogConfig, XpoDialogRef } from '@xpo/common';

import { Injectable } from '@angular/core';

@Injectable()
export class DialogsService {

    constructor(private dialog: XpoDialog) { }

    public confirm(title: string, message: string): Observable<boolean> {

        let dialogRef: XpoDialogRef<ConfirmDialog>;

        dialogRef = this.dialog.open(ConfirmDialog);
        dialogRef.componentInstance.title = title;
        dialogRef.componentInstance.message = message;

        return dialogRef.afterClosed();
    }
}



// WEBPACK FOOTER //
// /ng-app/src/core/services/dialogs.service.ts